import { twMerge } from "tailwind-merge";
import { Children } from "react";

export type Props = {
  children: React.ReactNode;
  layout?: "even" | "wide-left" | "wide-right";
};

export function TwoColumnsLayout({ children, layout = "wide-left" }: Props) {
  const [left, right] = Children.toArray(children);

  return (
    <div className="flex flex-col sm:flex-row gap-12 w-full">
      <div
        className={twMerge(
          "w-full",
          layout === "wide-left" && "flex-2 max-w-2xl",
          layout === "wide-right" && "flex-1 max-w-xs",
          layout === "even" && "flex-1"
        )}
      >
        {left}
      </div>
      <div
        className={twMerge(
          "w-full",
          layout === "wide-left" && "flex-1 md:max-w-xs",
          layout === "wide-right" && "flex-2 md:max-w-2xl",
          layout === "even" && "flex-1"
        )}
      >
        {right}
      </div>
    </div>
  );
}

export default TwoColumnsLayout;
